<template>
  <main>
    <md-card>
      <md-card-header>
        <div class="md-title">お問い合わせ・FAQ</div>
      </md-card-header>

      <md-card-content>
        <a href="#" @click="backToList()">
          <md-button class="md-raised">
            <md-icon>arrow_back</md-icon>
            <span>戻る</span>
          </md-button>
        </a>
      </md-card-content>

      <loading-spinner v-if="loadDetail"></loading-spinner>
      <md-card-content v-else-if="fetchDetail && errorNotFound()">
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <flash-message :errors="errorMessages"></flash-message>
          </div>
        </div>
      </md-card-content>
      <div class="md-layout" v-else-if="fetchDetail">
        <div class="md-layout-item md-size-20 md-small-size-100"></div>
        <div class="md-layout-item md-size-60 md-small-size-100">
          <flash-message :errors="errorMessages" v-if="errorMessages.length"></flash-message>
          <form @submit.prevent="submitForm" novalidate>
            <md-card-content>
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>カテゴリ</label>
                </div>
                <div class="md-layout-item">
                  <md-field :class="getValidationClass('category')">
                    <label>カテゴリ</label>
                    <md-select v-model="form.category" name="category">
                      <md-option v-for="category in categories" :value="category.id" :key="'category-' + category.id">
                        {{ category.name }}
                      </md-option>
                    </md-select>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('category')">{{
                        getValidationResponseMessage('category')
                      }}</span>
                    <span class="md-error" v-else-if="!$v.form.category.required">{{ errors.category.required }}</span>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>質問</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('question')">
                    <label>質問</label>
                    <md-input v-model="form.question" :disabled="sending"/>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('question')">{{
                        getValidationResponseMessage('question')
                      }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.question.required">{{ errors.question.required }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.question.maxLength">{{ errors.question.maxLength }}</span>
                  </md-field>
                </div>
              </div>

              <div>
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  回答
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field class="d-block" :class="getValidationClass('answer')">
                    <Editor v-model.trim="form.answer" :class="getValidationClass('answer')"
                            api-key="quvxculfjhfc3bi7pxuvfquelt3ia6hg3i651ncq08l11p2l"
                            @onKeyDown="keyEvent"
                            :init="{
                               language: 'ja',
                               height: 500,
                               menubar: false,
                               nowrap : true,
                               remove_linebreaks : false,
                               force_br_newlines : false,
                               force_p_newlines : false,
                               entity_encoding: 'raw',
                               extended_valid_elements: 'i[class]',
                               custom_elements: 'i',
                               images_upload_handler: imagesUploadHandler,
                               image_description: false,
                               automatic_uploads: true,
                               plugins: [
                                 'advlist autolink lists link charmap print preview anchor',
                                 'searchreplace visualblocks fullscreen  textpattern',
                                 'insertdatetime media help wordcount textcolor paste code image imagetools'
                               ],
                               toolbar:
                                 'undo redo | formatselect | bold italic forecolor backcolor | \
                                 alignleft aligncenter alignright alignjustify | \
                                 bullist numlist outdent indent | removeformat link | image code',
                               color_map: [
                                    '169179', 'green',
                                    'ba372a', 'red',
                                    'cf2124', 'light red',
                                    '0b0080', 'blue',
                                    '007020', 'green light',

                                    '0000FF', 'html attribute',
                                    '008000', 'html attribute value',
                                    '063FDB', 'function',
                                    '660E7A', 'js global variable',

                                    '000000', 'Black',
                                    'FFFFFF', 'White',
                               ],
                               table_default_attributes: {class : 'table table-striped table-bordered table-sm'},
                               table_default_styles: {width: '100%'},
                               invalid_styles: {'td' : 'width height', 'tr': 'width height', 'table' : 'height'},
                               textpattern_patterns: [
                                  {start: '#', format: 'h1'},
                                  {start: '##', format: 'h2'},
                                  {start: '###', format: 'h3'},
                                  {start: '####', format: 'h4'},
                                  {start: '#####', format: 'h5'},
                                  {start: '######', format: 'h6'},
                                  {start: '```', replacement: '<pre>Code Block</pre>'},
                                  {start: '`', replacement: '<code>Highlight</code>'},
                               ],
                               content_style: 'code{background-color:#f4f5f7;border-radius:3px;box-shadow:0 0 0 1px rgba(9,30,66,.13);color:#eb5a46;padding:1px 3px;margin:-1px 2px}pre{background-color:#f4f5f7;border-radius:3px;box-shadow:0 0 0 1px rgba(9,30,66,.13);margin-bottom:16px;padding:8px 12px;word-break:normal;word-wrap:normal;overflow-wrap:normal}.table{width:100%;margin-bottom:1rem;background-color:transparent;border-collapse:collapse}.table-bordered{border:1px solid #dee2e6}.table-striped tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.05)}.table td,.table th{padding:.75rem;vertical-align:top;border-top:1px solid #dee2e6}.table-sm td,.table-sm th{padding:.3rem}.text-white{color:#fff!important}.bg-primary{background-color:#2c9676!important}.font-weight-bold{font-weight: 700!important;}',
                          }"
                    />
                    <span class="md-error 1"
                          v-if="getValidationResponseMessage('answer')">{{
                        getValidationResponseMessage('answer')
                      }}</span>
                    <span class="md-error 2"
                          v-else-if="!$v.form.answer.required">{{ errors.answer.required }}</span>
                    <span class="md-error 3"
                          v-else-if="!$v.form.answer.maxLength">{{ errors.answer.maxLength }}</span>
                    <span class="md-error" v-if="errorMessage">{{ errorMessage }}</span>
                  </md-field>
                </div>
              </div>
            </md-card-content>

            <md-card-actions class="md-layout md-alignment-center-center">
              <md-button :disabled="sending" class="md-raised md-primary" type="submit" style="margin-bottom: 35px;">
                <md-icon>save</md-icon>
                <span>登録する</span>
              </md-button>
            </md-card-actions>
          </form>
        </div>
      </div>
    </md-card>
    <md-snackbar :md-active.sync="showSnackBar"
                 :md-duration="snackbarDuration"
                 @md-closed="showSnackBar = false">
      <span>{{ successMessage }}</span>
      <md-button class="md-primary" @click="showSnackBar = false" :disabled="sending">閉じる</md-button>
    </md-snackbar>
  </main>
</template>

<script>
import 'vue-datetime/dist/vue-datetime.css'
import {validationMixin}                                 from 'vuelidate'
import {maxLength, required,}                            from 'vuelidate/lib/validators'
import {mapActions}                                      from 'vuex';
import FlashMessage                                      from '../../../components/FlashMessage';
import LoadingSpinner                                    from '../../../components/LoadingSpinner';
import {apiClientWithManagerToken as apiClient, apiList} from '../../../modules/apiClient';
import Common                                            from '../../../modules/common';
import Validation                                        from '../../../modules/validation';
import CommonMixin                                       from '../../../mixins/commonMixin';
import Editor                                            from '@tinymce/tinymce-vue';

export default {
  name      : "BackendAdminFaqNew",
  components: {
    FlashMessage,
    LoadingSpinner,
    Editor,
  },
  mixins    : [CommonMixin, validationMixin],
  props     : {
    id: String
  },
  data      : () => ({
    loadDetail      : false,
    categories      : [],
    faqId           : null,
    errorMessages   : [],
    errorMessage    : null,
    validateResponse: [],
    editor          : null,
    form            : {
      category: null,
      question: null,
      answer  : null,
    },
    errors          : {
      category: {
        required: Validation.errorMessage(Validation.rules.required, 'category'),
      },
      question: {
        required : Validation.errorMessage(Validation.rules.required, 'question'),
        maxLength: Validation.errorMessage(Validation.rules.maxLength, 'question', 255),
      },
      answer  : {
        required : Validation.errorMessage(Validation.rules.required, 'answer'),
        maxLength: Validation.errorMessage(Validation.rules.maxLength, 'answer', 65535),
      },
    },
  }),
  validations() {
    return {
      form: {
        category: {
          required,
        },
        question: {
          required,
          maxLength: maxLength(255),
        },
        answer  : {
          required,
          maxLength: maxLength(65535),
        },
      },
    };
  },
  mounted: function () {
    this.getFaqs();
    if (this.$props.id) {
      this.faqId = this.$props.id;
      this.getFaqDetail();
    } else {
      this.fetchDetail = true;
    }
  },
  beforeDestroy() {
    this.editor.destroy();
  },
  methods: {
    ...mapActions('adminFaqs', [
      'saveBack',
    ]),
    keyEvent (event, editor) {
      if (event.keyCode == 9) { // tab process
        event.preventDefault();
        editor.execCommand('mceInsertContent', false, "&nbsp;&nbsp;&nbsp;&nbsp;");
      }
    },
    async imagesUploadHandler(blobInfo, success, failure, progress) {
      var file = blobInfo.blob();
      let formData      = new FormData();
      formData.append("file", file);
      apiClient
          .post(apiList.upload.image, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            }
          })
          .then(response => {
            if (this.hasResponseErrors(response)) {
              if (this.errorMessages.length) {
                this.errorMessage = this.errorMessages[0];
                return;
              }
              if (this.validateResponse.length) {
                this.errorMessage = this.validateResponse[0]['message'];
              }
              return;
            }
            success(response.data.url);
          })
          .catch(error => {
            this.errorMessage = error.message;
          })
          .finally(() => {
            this.sending = false;
          });
    },
    backToList() {
      this.saveBack(true);
      this.$router.replace({name: 'BackendAdminFaqs'}).then();
    },
    errorNotFound() {
      if (this.$props.id) {
        if (!this.faqId) {
          this.errorMessages = [Common.messages.faqEdit.notFound];
          return true;
        }
      }
      return false;
    },
    getFaqs() {
      this.sending = true;
      apiClient
          .get(apiList.faq.list)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.categories = response.data;
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false
          });
    },
    getFaqDetail() {
      this.successMessage = null;
      this.sending        = true;
      this.loadDetail     = true;
      const detailUrl     = apiList.faq.detail.replace(':id', this.faqId);
      apiClient.get(detailUrl)
          .then(response => {
            const result = response.data;
            if (result.errors) {
              this.faqId         = null;
              this.errorMessages = result.errors;
              return;
            }
            this.form.category = result.faq_category_id;
            this.form.question = result.question;
            this.form.answer   = result.answer;
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending     = false;
            this.loadDetail  = false;
            this.fetchDetail = true;
          });
    },
    updateFaq() {
      this.sending          = true;
      this.validateResponse = [];
      const url             = apiList.faq.update.replace(':id', this.faqId);
      apiClient.put(url, this.form)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }

            if (this.faqId) {
              this.setSnackBar(Common.messages.faqEdit.updateSuccess);
              this.backToList();
            } else {
              this.errorMessages = [Common.messages.faqEdit.updateError];
            }
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false;
            this.$v.$reset();
          });
    },
    registerFaq() {
      this.sending          = true;
      this.validateResponse = [];
      apiClient.post(apiList.faq.register, this.form)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.faqId = null;
            this.setSnackBar(Common.messages.faqEdit.registerSuccess);
            this.backToList();
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false;
            this.$v.$reset();
          });
    },
    submitForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.$props.id) {
          this.updateFaq();
        } else {
          this.registerFaq();
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
